var React = require('react');

function ExclamationMark (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#FF9255","fillOpacity":"0.1","key":0}),React.createElement("path",{"d":"M12 7V13","stroke":"#FF9255","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("circle",{"cx":"12","cy":"17","r":"1","fill":"#FF9255","key":2})]);
}

ExclamationMark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ExclamationMark;

ExclamationMark.default = ExclamationMark;
